import { TicketResponse } from "@/types/ticket/ticketValidation";

export async function getTicketByUuid(uuid: string): Promise<TicketResponse> {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/tickets/validate/${uuid}`, {
        credentials: 'include'
    });
    if (response.status === 404) {
        throw new Error('That ticket does not exist.');
    }
    if (response.status === 401) {
        throw new Error('Please log in to your organization to view this ticket.');
    }
    if (response.status === 403) {
        const errorData = await response.json();
        if (errorData.accessDenied) {
            throw new Error('You do not have access to this ticket. Please log in to the correct organization.');
        }
        throw new Error('Access denied.');
    }
    if (!response.ok) {
        throw new Error('Failed to fetch ticket.');
    }
    return response.json();
}